var map = {
	"./airplanes-10s.mp4": 3032,
	"./create-the-ans-10s.mp4": 5108,
	"./galaxy-s9-10s.mp4": 8306,
	"./her-10s.mp4": 9462,
	"./ipad-10s.mp4": 6018,
	"./one-in-a-b-10s.mp4": 6654,
	"./originals-10s.mp4": 2376,
	"./pandg-10s.mp4": 7704,
	"./snowden-10s.mp4": 9138,
	"./vodafone-10s.mp4": 6519
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5868;